"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="ja">
      <body>
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <h1>エラーが発生しました</h1>
          <p>申し訳ありません。予期しないエラーが発生しました。</p>
          <button onClick={() => reset()}>再試行</button>
        </div>
      </body>
    </html>
  );
}
